import {Form} from "react-bootstrap";
import {Field, useField} from "formik";
import {FormFieldProps} from "./FormField";

export const SelectFormField = (props: FormFieldProps) => {

    const [field] = useField(props.id);

    const options = props.options || [];

    const buildOptions = (selected?: string) => {
        return [
            <option value={''}>Choisissez...</option>,
            ...options.map(option => <option value={option.value} selected={option.value === selected}>{option.label}</option>)
        ]
    }

    return (
        <>
            <Form.Label htmlFor={props.id}>
                {props.label}
            </Form.Label>
            {
                <Field
                    {...field}
                    as={Form.Select}
                    type={props.type}
                    id={props.id}
                    name={props.id}
                    value={field.value && field.value.id}
                    isInvalid={props.touched && !!props.error}
                    isValid={props.touched && !props.error}
                >
                    {buildOptions(field.value)}
                </Field>
            }
        </>
    )
}